import axios from 'axios';
import {
  CREATE_MESSAGES,
  CREATE_MESSAGES_SCHEDULE,
  CREATE_MESSAGES_STATUS,
  BGC_LOADING,
  BGC_LOADED,
  BGC_FETCH_ERROR
} from './types';

import { tokenConfig } from './auth';

export const get_bgc_screening = () => async (dispatch, getState) => {
  dispatch({ type: BGC_LOADING })

  await axios.get(`${process.env.REACT_APP_API_URL}screenings/`, tokenConfig(getState))
    .then((res) => {

      console.log("res.data: /screenings/")
      console.log(res.data?.results[0])
      dispatch({ type: BGC_LOADED, payload: res.data?.results[0] })

    })
    .catch((e) => {
      dispatch({ type: BGC_FETCH_ERROR })
    })
}

// CREATE MESSAGE
export const createMessage = (msg) => {
  return {
    type: CREATE_MESSAGES,
    payload: msg
  };
};

// CREATE MESSAGE
export const createMessage_status = (msg, id) => {
  return {
    type: CREATE_MESSAGES_STATUS,
    payload: msg,
    payload_id: id
  };
};

// CREATE MESSAGE
export const createMessage_schedules = (msg) => {
  return {
    type: CREATE_MESSAGES_SCHEDULE,
    payload: msg
  };
};
